<template>
  <div id="news">
    <div class="news-top">
      <Header/>
      <div class="breadcrumb-bg">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item><router-link class="link-back" to="/">首頁</router-link></el-breadcrumb-item>
          <el-breadcrumb-item class="current">最新資訊</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="news-bottom">
      <div class="container boxx">
        <!-- 
        <div class="container-bg"><h4>最新資訊</h4></div> 

        //vue-waterfall-easy 点击事件
        @click="clickFn"
        -->
        <vue-waterfall-easy 
        ref="waterfall"
        :imgWidth="imgWidth"
        :gap="20"
        :mobileGap="8"
        :enablePullDownEvent="true"
        :imgsArr="imgsArr"
        srcKey="mainImage"
        hrefKey="id"
        @scrollReachBottom="getData"
        @imgError="imgErrorFn"
        :maxCols="maxCols"
        :loadingDotCount="3" 
         >
          <div class="img-info" slot-scope="props">
            <div class="title-info"><h4>{{props.value.title}}</h4></div>
            <p class="content-info" :hidden="props.value.summary == ''">{{props.value.summary}}</p>
          </div>
        </vue-waterfall-easy>
      </div>
      <!-- <Footer/> -->
    </div>
    <router-view></router-view>
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Header from '../components/Header.vue'      //公共头部
import Footer from '../components/Footer.vue'      //底部
import vueWaterfallEasy from './news/vue-waterfall-easy/vue-waterfall-easy.vue'
import { reqNewsList } from '../untils/api.js'


export default {
  name: 'News',
  data () {
    return {  
      imgWidth: 222,
      maxCols: 4,
      imgsArr: [],
      total: 0,
      status: 1,
      pageCount: 0,  //一共多少页
      currentPage: 0, //当前页
      pageSize: 10, //一页展示多少
  
      // pullDownDistance: 0
    }
  },
  created() {
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData() {
      this.currentPage++
      let data = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        status: this.status
      }
      // console.log('data', data)
      reqNewsList(data).then(res => {
        // console.log('res', res)
        if (res.code == 200) {
          let data = res.data.data
          this.pageCount = data.pages
          // console.log('this.currentPage', this.currentPage)
          // console.log(' this.pageCount', this.pageCount)
          if(this.currentPage > this.pageCount) {
            this.$refs.waterfall.waterfallOver()
            return
          }
          this.imgsArr = this.imgsArr.concat(data.list) 
        }
      })
    },
    clickFn(event, { index, value }) {
      event.preventDefault()
      if (event.target.tagName.toLowerCase() == 'img') {
        // console.log('img clicked', index, value)
      }
    },
    imgErrorFn(imgItem){
      console.log('图片加载错误',imgItem)
    },
    // pullDownMove(pullDownDistance) {
    //   // console.log('pullDownDistance', pullDownDistance)
    //   this.pullDownDistance = pullDownDistance
    // },
    // pullDownEnd(pullDownDistance) {
    //   console.log('pullDownEnd')
    //   if(this.pullDownDistance>50){
    //     alert('下拉刷新')
    //   }
    //   this.pullDownDistance = 0
    // }
  },
  components: {
    Header,
    Footer,
    vueWaterfallEasy
  }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
  html, body {
    height: 100%;
  }
  .el-breadcrumb__inner a {
    font-weight: normal; 
    &:hover {
      color: #606266;
    }
  }
  .vue-waterfall-easy-container {
    overflow-y: hidden;
  }
  img{
    height: auto;
  }
  #news {
    background: #f4f4f4;
    // position: relative;
    max-width: 1440px;
    margin: 0 auto;
    box-shadow: 0 0 16px #a6a6a6;
    background: #f3f3f3;
    height: 100%;
    overflow-y: hidden;
    .news-top {
      width: 100%;
      position: fixed;
      top: 0;
      z-index: 99;
      .breadcrumb-bg {
        margin-top: 50px;
        box-shadow: 0 3px 2px rgba(0,0,0,0.1);
        background: #f3f3f3;
        .breadcrumb {
          padding: 10px 10px 6px !important;
        }
        .el-breadcrumb {
          font-size: 13px;
          line-height: 16px;
          padding: 10px 0;
          background: #f3f3f3;
          span {
            padding-bottom: 3px;
            &:last-of-type {
              width: 170px;
              display: inline-block;
              white-space: nowrap; 
              overflow: hidden;
              text-overflow:ellipsis;
            }
          }
        }
      }
    }
    .news-bottom {
      width: 100%;
      height: 100%;
      position: relative;
      top: 0;
      padding-top: 85px;
      // padding-bottom: 76px;
      overflow-y: hidden;
      overflow: hidden;
      .boxx {
        // background-color: #FFFFFF;
        background-color: #f3f3f3;
        color: #545454;
        position: relative;
        margin-top: 20px;
        width: 100%;
        height: 100%;
        overflow-y: hidden;
      }
      .container {
      }
    }
    .img-info {
      font-family: 'Microsoft YaHei', 'arial';
      .title-info {
        border-bottom: 1px solid rgba(0,0,0,.1);
        // padding-top: 15px;
        // padding-bottom: 15px;
        padding: 15px 12px;
        h4 {
          color: #000000;
          font-weight: 600;
          font-size: 12px;
          font-weight: bold;
          line-height: 18px;
        }
      }
      .content-info {
        color: #6A6A6A;
        line-height: 18px;
        font-size: 12px;
        padding: 8px 12px;
      }
    }
  }
  a {
    color: #000;
    text-decoration: none;
    &:active {
      color: #000;
    }
  }

 

  @media (min-width: 768px) {

    #news {
      .news-top {
        .breadcrumb-bg {
          margin-top: 50px;
          .el-breadcrumb {
            span {
              &:last-of-type {
                width: 400px;
              }
            }
          }
        }
      }
      .news-bottom {
        .container {
          .container-bg {
            width: 750px;
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    #news {
      .news-top {
        .breadcrumb-bg {
          margin-top: 0;
          .el-breadcrumb {
            span {
              &:last-of-type {
                width: 600px;
              }
            }
          }
        }
      }
      .news-bottom {
        padding-top: 137px;
        .container {
          .container-bg {
            width: 970px;
          }
        }
      }
    }
  }  

  @media (min-width: 1200px) {
    #news {
      .news-top {
        .breadcrumb-bg {
          margin-top: 0;
          .el-breadcrumb {
            span {
              &:last-of-type {
                width: auto;
              }
            }
          }
        }
      }
      .news-bottom {
        .container {
          .container-bg {
            width: 990px;
          }
        }
      }
    }
  }

  @media (min-width: 1439px) {
    #news {
      .news-top {
        width: 1440px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/News.vue